import { client, getUrl } from "utils";

export const getMetricTasksRequest = (filterParams) => client.get(getUrl("metric-tasks", filterParams));

export const getMetricTaskByCodeRequest = (code) => client.get(`metric-task/${code}`);

export const getMetricDataRequest = (filterParams) => client.get(getUrl("metric-data", filterParams));

export const getMetricDataCountRequest = (filterParams) => client.get(getUrl("metric-data/count", filterParams));

export const updateMetricTaskRequest = (code) => client.post(getUrl(`metric-task/${code}/start`));

export const getTaskByCodeRequest = (code) => client.get(getUrl(`metric-task/${code}`));

export const createTaskRequest = (data) => client.post("metric-tasks", data);

export const updateTaskRequest = ({ code, values }) => client.patch(`metric-task/${code}`, values);

export const updateAllTaskDataRequest = ({ code, values }) => client.put(`metric-task/${code}`, values);

export const deleteTaskRequest = (code) => client.delete(`metric-task/${code}`);
